import * as React from "react";

export function IconoCerrar(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      viewBox="0 0 24 24"
      width="100%"
      height="100%"
    >
      <path
        fill="currentColor"
        d="M4.293,19.707a1,1,0,0,0,1.414,0L12,13.414l6.293,6.293a1,1,0,0,0,1.414-1.414L13.414,12l6.293-6.293a1,1,0,1,0-1.414-1.414L12,10.586,5.707,4.293A1,1,0,0,0,4.293,5.707L10.586,12,4.293,18.293A1,1,0,0,0,4.293,19.707Z"
      />
    </svg>
  );
}

export function IconoLenguaje(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      enableBackground="new 0 0 135 135"
      viewBox="0 0 135 135"
      // width="50%"
      // height="50%"
      id="Languages"
    >
      <g fill="#000000" className="color000000 svgShape">
        <path
          fill="#153b5e"
          d="M131.5,67.4949799c0,35.3466797-28.6481781,64.0051422-63.9948578,64.0051422S3.5,102.8416595,3.5,67.4949799S32.1584625,3.4998777,67.5051422,3.4998777S131.5,32.148304,131.5,67.4949799z"
          className="color592c84 svgShape"
        ></path>
        <path
          fill="#114c83"
          d="M115.9337921,68.3800507c-0.468338,26.3604202-21.9683609,47.561821-48.4337921,47.561821c-26.8069916,0-48.4418716-21.7386932-48.4418716-48.4418716c0-26.7479897,21.6857986-48.4418716,48.4418716-48.4418716C95.2347565,19.0581284,116.6615067,42.2043381,115.9337921,68.3800507z"
          className="color561183 svgShape"
        ></path>
        <path
          fill="#50ffe9"
          d="M84.5,18.7849312v31.0100098c0,1.9899902-1.619873,3.6000366-3.6098633,3.6000366H50.3601074l-7.130127,7.1300049c-1.079834,1.0799561-2.9199219,0.3099976-2.9199219-1.2200317v-5.9099731H35.920166c-1.9902344,0-3.6101074-1.6100464-3.6101074-3.6000366V18.7849312c0-1.9899902,1.619873-3.6099854,3.6101074-3.6099854h44.9699707C82.880127,15.1749458,84.5,16.7949409,84.5,18.7849312z"
          className="colorffbc50 svgShape"
        ></path>
        <path
          fill="#2cffe5"
          d="M84.5,37.7549629v12.039978c0,1.9899902-1.619873,3.6000366-3.6098633,3.6000366H65.380127v-9.0300293c0-3.6400146,2.9699707-6.6099854,6.6098633-6.6099854H84.5z"
          className="colorffb32c svgShape"
        ></path>
        <path
          fill="#ffffff"
          d="M48.548584,42.5171089l7.2919922-17.2138672c0.3130569-0.7053795,0.8752747-1.1723633,1.6582031-1.1723633c0.169548,0.0181656,0.7691116-0.0929852,1.3017578,0.3286133c0.2753906,0.2197266,0.4902344,0.5004883,0.6435547,0.84375c7.566391,17.9459572,7.4345703,17.350914,7.4345703,17.7861328c0,1.4507408-1.9281387,1.7633553-2.5166016,0.4858398l-1.8583984-4.4609375h-9.7226563l-1.8583984,4.4609375C50.2252159,45.0892143,47.8053513,44.3138962,48.548584,42.5171089z M53.7819824,36.74123h7.7207031l-3.8603516-9.293457L53.7819824,36.74123z"
          className="colorffffff svgShape"
        ></path>
        <path
          fill="#ffffff"
          d="M64.7800293,44.2876167c-0.6845016-0.4485168-0.5514832-0.8638458-2.3759766-5.0234375h-9.5234375l-1.8193359,4.3686523c-0.468605,1.0176964-1.7507019,1.1550598-2.40625,0.4755859l0,0c-0.3923378-0.4082642-0.5260353-0.9686699-0.2451172-1.6484375l7.2929688-17.215332c0.3342323-0.7530327,0.9429016-1.2636719,1.7958984-1.2636719c0.1695023,0.0188751,0.8141785-0.097826,1.3945313,0.3608398c0.2949219,0.2348633,0.5253906,0.5375977,0.6875,0.9003906c7.5488434,17.9115486,7.4482422,17.3562775,7.4482422,17.847168C67.0290527,44.2964363,65.741272,44.9105034,64.7800293,44.2876167z M52.7810059,38.9643745h9.7226563c0.0605469,0,0.1152344,0.0361328,0.1386719,0.0922852c1.8894806,4.3507118,1.7482376,4.617897,2.3017578,4.9794922c0.909668,0.5876808,2.1743546-0.2144089,1.6523438-1.4614258l-7.2900391-17.2128906c-0.293293-0.6543446-0.8011856-1.0810547-1.5214844-1.0810547c-0.1652908,0.017168-0.7216644-0.0879211-1.2080078,0.2963867c-0.2558594,0.2041016-0.4580078,0.46875-0.5996094,0.7871094c-7.5796509,17.9701233-7.4208984,17.3416176-7.4208984,17.7250977c0,0.3251953,0.1025391,0.590332,0.3154297,0.8110352l0,0c0.5122147,0.5323715,1.5409508,0.4273338,1.9140625-0.3881836l1.8564453-4.4555664C52.6657715,39.0005074,52.720459,38.9643745,52.7810059,38.9643745z M61.5026855,36.8911324h-7.7207031c-0.0498047,0-0.0966797-0.0249023-0.125-0.0664063c-0.0273438-0.0419922-0.0332031-0.0947266-0.0136719-0.1411133l3.8603516-9.293457c0.046875-0.1113281,0.2304688-0.1113281,0.2773438,0l3.8603516,9.293457c0.0195313,0.0463867,0.0136719,0.0991211-0.0136719,0.1411133C61.5993652,36.86623,61.5524902,36.8911324,61.5026855,36.8911324z M54.0065918,36.5913277h7.2714844l-3.6357422-8.7524414L54.0065918,36.5913277z"
          className="colorffffff svgShape"
        ></path>
        <path
          fill="#2cffe5"
          d="M35.0300293 18.7849312v31.0100098c0 1.9899902 1.6201172 3.6000366 3.6101074 3.6000366H35.920166c-1.9902344 0-3.6101074-1.6100464-3.6101074-3.6000366V18.7849312c0-1.9899902 1.619873-3.6099854 3.6101074-3.6099854h2.7199707C36.6501465 15.1749458 35.0300293 16.7949409 35.0300293 18.7849312zM43.3901367 60.3649483l-.1601563.1600342c-1.079834 1.0799561-2.9199219.3099976-2.9199219-1.2200317v-5.9099731h2.7199707v5.9099731C43.0300293 59.7249336 43.170166 60.08498 43.3901367 60.3649483z"
          className="colorffb32c svgShape"
        ></path>
        <path
          fill="#54abfc"
          d="M120.5700684,44.3649483v31.0000038c0,2-1.6201172,3.6099854-3.6098633,3.6099854h-4.3901367v5.9100342c0,1.5299683-1.8400879,2.2999878-2.9199219,1.2199707l-7.130127-7.1300049H71.9899902c-1.9899902,0-3.6098633-1.6099854-3.6098633-3.6099854V44.3649483c0-1.9899902,1.619873-3.6099854,3.6098633-3.6099854h44.9702148C118.9499512,40.7549629,120.5700684,42.374958,120.5700684,44.3649483z"
          className="colorfc545d svgShape"
        ></path>
        <path
          fill="#449ef1"
          d="M82.8901367 77.5949936v1.3799438H71.9899902c-1.9899902 0-3.6098633-1.6099854-3.6098633-3.6099854v-4.3800049h7.9099121C79.9299316 70.9849472 82.8901367 73.9549789 82.8901367 77.5949936zM109.5700684 78.9749374h3v5.9100342c0 1.5299683-1.8400879 2.2999878-2.9199219 1.2199707l-.3300781-.3299561C109.7576065 85.09095 109.4889069 84.8761978 109.5700684 78.9749374zM120.5700684 44.3649483v31.0000038c0 2-1.6201172 3.6099854-3.6098633 3.6099854h-3c1.9897461 0 3.6098633-1.6099854 3.6098633-3.6099854V44.3649483c0-1.9899902-1.6201172-3.6099854-3.6098633-3.6099854h3C118.9499512 40.7549629 120.5700684 42.374958 120.5700684 44.3649483z"
          className="colorf14448 svgShape"
        ></path>
        <g fill="#000000" className="color000000 svgShape">
          <path
            fill="#07eace"
            d="M79.8901367,77.5949936v31c0,1.9899902-1.6101074,3.6099854-3.6000977,3.6099854H45.75l-7.119873,7.1199951c-1.0800781,1.0800171-2.9301758,0.3200073-2.9301758-1.210022v-5.9099731h-4.3898926c-1.9899902,0-3.5998535-1.6199951-3.5998535-3.6099854v-31c0-2,1.6098633-3.6100464,3.5998535-3.6100464h44.9799805C78.2800293,73.9849472,79.8901367,75.5949936,79.8901367,77.5949936z"
            className="color43a1ff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000000 svgShape">
          <path
            fill="#2cffe5"
            d="M30.6901855 77.5949936v31c0 1.9899902 1.6098633 3.6099854 3.5998535 3.6099854h-2.9799805c-1.9899902 0-3.5998535-1.6199951-3.5998535-3.6099854v-31c0-2 1.6098633-3.6100464 3.5998535-3.6100464h2.9799805C32.3000488 73.9849472 30.6901855 75.5949936 30.6901855 77.5949936zM38.9401855 119.0149765l-.3100586.3099976c-1.0800781 1.0800171-2.9301758.3200073-2.9301758-1.210022v-5.9099731h2.9799805v5.9099731C38.6799316 118.4549789 38.7700195 118.7649765 38.9401855 119.0149765z"
            className="color2c8cff svgShape"
          ></path>
        </g>
        <g opacity=".3" fill="#000000" className="color000000 svgShape">
          <path
            fill="#ffffff"
            d="M58.5114975 18.8104744c0 .6301022-.5154381 1.1455383-1.1455383 1.1455383H39.9196205c-.6301041 0-1.1455383-.5154362-1.1455383-1.1455383 0-.6414986.5154343-1.1455383 1.1455383-1.1455383h17.4463387C57.9960594 17.6649361 58.5114975 18.1689758 58.5114975 18.8104744zM66.5905991 18.8104744c0 .6301022-.5154343 1.1455383-1.1455383 1.1455383h-3.6811066c-.6301041 0-1.1455383-.5154362-1.1455383-1.1455383 0-.6414986.5154343-1.1455383 1.1455383-1.1455383h3.6811066C66.0751648 17.6649361 66.5905991 18.1689758 66.5905991 18.8104744z"
            className="colorffffff svgShape"
          ></path>
        </g>
        <g opacity=".3" fill="#000000" className="color000000 svgShape">
          <path
            fill="#ffffff"
            d="M95.7502899 44.4294319c0 .6301003-.5154343 1.1455383-1.1455383 1.1455383h-7.4463425c-.6300964 0-1.1455383-.5154381-1.1455383-1.1455383 0-.6414986.5154419-1.1455383 1.1455383-1.1455383h7.4463425C95.2348557 43.2838936 95.7502899 43.7879333 95.7502899 44.4294319zM113.8293915 44.4294319c0 .6301003-.5154343 1.1455383-1.1455383 1.1455383H99.0027466c-.6301041 0-1.1455383-.5154381-1.1455383-1.1455383 0-.6414986.5154343-1.1455383 1.1455383-1.1455383h13.6811066C113.3139572 43.2838936 113.8293915 43.7879333 113.8293915 44.4294319z"
            className="colorffffff svgShape"
          ></path>
        </g>
        <g opacity=".3" fill="#000000" className="color000000 svgShape">
          <path
            fill="#ffffff"
            d="M76.0700455 87.0540314c.6300964 0 1.1455383.5154419 1.1455383 1.1455383l-.0000076 17.4463425c0 .6301041-.5154419 1.1455383-1.145546 1.1455383-.6414948 0-1.1455383-.5154343-1.1455383-1.1455383l.0000153-17.4463425C74.9245071 87.5694733 75.4285431 87.0540314 76.0700455 87.0540314zM76.0700455 78.9749374c.6301041 0 1.1455383.5154343 1.1455383 1.1455383v3.6811066c0 .6300964-.5154343 1.1455383-1.1455383 1.1455383-.6415024 0-1.1455383-.5154419-1.1455383-1.1455383v-3.6811066C74.9245071 79.4903717 75.4285507 78.9749374 76.0700455 78.9749374z"
            className="colorffffff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000000 svgShape">
          <path
            fill="#ffffff"
            d="M100.8038559,56.6218681c-0.2720718,1.552803-1.1063004,4.9698219-3.6886139,8.1929741c1.7082672,1.4755478,3.6497498,2.6984482,5.8244324,3.6303177c1.6116257,0.6284485,0.893425,3.3404541-1.1650772,2.7178802c-2.4657135-1.0674362-4.6982269-2.4652405-6.6596069-4.1934204c-2.0770416,1.8831711-4.6783142,3.300415-7.7071304,4.2133255c-0.1166077,0.0777359-0.2910385,0.0777359-0.4275436,0.0777359c-1.6957245,0-2.0558624-2.4099884-0.4076385-2.8932571c2.5244904-0.7569656,4.699173-1.9026108,6.465271-3.4364471c-1.1840363-1.378376-2.1936417-2.8923111-2.9899521-4.5038872c-0.586441-1.1427422,0.5182495-2.4327202,1.7670517-2.0580788c1.1946487,0.4407005,0.7479553,1.4141235,3.2421112,4.3683205c1.747139-2.3102417,2.4657135-4.6982231,2.7567444-6.1154633H85.4663773c-0.8152695,0-1.4750671-0.6602707-1.4750671-1.4949722c0-0.8351784,0.6597977-1.475544,1.4750671-1.475544h7.5137482v-2.1746788c0-0.8152695,0.6597977-1.475544,1.4750671-1.475544c0.8351746,0,1.4760132,0.6408424,1.4760132,1.475544v2.1746788h7.5516586c0.8162231,0,1.4760208,0.6598015,1.4760208,1.475544c0,0.8152695-0.6597977,1.4949722-1.4760208,1.4949722H100.8038559z"
            className="colorffffff svgShape"
          ></path>
        </g>
        <g fill="#000000" className="color000000 svgShape">
          <path
            fill="#ffffff"
            d="M61.0344124 103.3110275c0 .9129181-.7442017 1.6568069-1.6568108 1.6568069-.9130211 0-1.6568108-.7438889-1.6568108-1.6568069 0-.9130249.7437897-1.6399918 1.6568108-1.6399918C60.2902107 101.6710358 61.0344124 102.3980026 61.0344124 103.3110275zM65.5261383 103.3110275c0 .9129181-.7442017 1.6568069-1.6568108 1.6568069-.9130211 0-1.6568108-.7438889-1.6568108-1.6568069 0-.9130249.7437897-1.6399918 1.6568108-1.6399918C64.7819366 101.6710358 65.5261383 102.3980026 65.5261383 103.3110275z"
            className="colorffffff svgShape"
          ></path>
          <g fill="#000000" className="color000000 svgShape">
            <path
              fill="#ffffff"
              d="M54.0930786 79.5809631v17.535141c0 4.0817566-3.313736 7.3953247-7.3809128 7.3953247-4.0817566 0-7.3951492-3.3135681-7.3951492-7.3953247v-2.9010849c0-.7395477.6114311-1.3511505 1.3509827-1.3511505.7395477 0 1.3509789.6116028 1.3509789 1.3511505v2.9010849c0 2.5884247 2.104763 4.6931915 4.6931877 4.6931915 2.5738411 0 4.6789551-2.1047668 4.6789551-4.6931915v-17.535141c0-.7393723.6114273-1.350975 1.3509789-1.350975C53.4958839 78.2299881 54.0930786 78.8415909 54.0930786 79.5809631zM66.3095322 94.5136185v1.1093216c0 2.5882492-2.1047592 4.6930161-4.6931839 4.6930161s-4.6789551-2.1047668-4.6789551-4.6930161V84.1462097c0-.7395477.5971947-1.3511505 1.3509789-1.3511505.7395515 0 1.3513298.6116028 1.3513298 1.3511505v11.4767303c0 1.0950928.8815575 1.9910583 1.9766464 1.9910583s1.9908791-.8959656 1.9908791-1.9910583v-1.1093216c0-.7536087.6114311-1.3509827 1.3509789-1.3509827C65.6977615 93.1626358 66.3095322 93.7600098 66.3095322 94.5136185z"
              className="colorffffff svgShape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconoOlvidoSuClave(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      enableBackground="new 0 0 100 100"
      viewBox="0 0 100 100"
      width="50%"
      height="50%"
      id="ForgotPassword"
    >
      <path
        fill="#ffffff"
        d="M84.952,50c0,19.303-15.649,34.952-34.952,34.952c-19.303,0-34.952-15.649-34.952-34.952
				c0-19.304,15.649-34.952,34.952-34.952C69.304,15.048,84.952,30.696,84.952,50z"
        className="colorffffff svgShape"
      ></path>
      <path
        d="M50,86.08C30.106,86.08,13.92,69.894,13.92,50c0-19.894,16.185-36.08,36.079-36.08c19.894,0,36.08,16.186,36.08,36.08
				C86.08,69.894,69.894,86.08,50,86.08z M50,16.175c-18.65,0-33.824,15.174-33.824,33.825c0,18.651,15.174,33.824,33.824,33.824
				c18.651,0,33.825-15.174,33.825-33.824C83.825,31.349,68.651,16.175,50,16.175z"
        fill="#153b5e"
        className="color000000 svgShape"
      ></path>
      <path
        fill="#07eace"
        d="M80.442,50c0,16.812-13.629,30.442-30.442,30.442c-16.812,0-30.442-13.63-30.442-30.442
				c0-16.813,13.629-30.443,30.442-30.443C66.813,19.558,80.442,33.187,80.442,50z"
        className="colorffafa4 svgShape"
      ></path>
      <path
        d="M50,81.57C32.592,81.57,18.43,67.408,18.43,50c0-17.408,14.162-31.57,31.569-31.57c17.408,0,31.57,14.162,31.57,31.57
				C81.57,67.408,67.408,81.57,50,81.57z M50,20.685c-16.164,0-29.314,13.15-29.314,29.315c0,16.165,13.151,29.314,29.314,29.314
				c16.165,0,29.315-13.15,29.315-29.314C79.315,33.835,66.165,20.685,50,20.685z"
        fill="#153b5e"
        className="color000000 svgShape"
      ></path>
      <path
        fill="#7f7f7f"
        d="M58.47,46.618H41.53c-0.304,0-0.55-0.246-0.55-0.55V31.383
												c0-0.152,0.062-0.289,0.161-0.389c0.099-0.1,0.236-0.161,0.389-0.161H58.47c0.304,0,0.55,0.246,0.55,0.55v14.685
												C59.02,46.371,58.774,46.618,58.47,46.618z"
        className="color7f7f7f svgShape"
      ></path>
      <path
        d="M57.892,47.745H42.108c-1.244,0-2.255-1.012-2.255-2.255V31.96c0-1.243,1.011-2.255,2.255-2.255h15.784
												c1.243,0,2.255,1.012,2.255,2.255v13.53C60.147,46.733,59.135,47.745,57.892,47.745z M42.108,31.96v13.53h15.787
												l-0.002-13.53H42.108z"
        fill="#153b5e"
        className="color000000 svgShape"
      ></path>
      <path
        d="M55.637,31.96h-2.255v-3.382c0-1.243-1.011-2.255-2.255-2.255h-2.255c-1.243,0-2.254,1.012-2.254,2.255v3.382
												h-2.255v-3.382c0-2.487,2.023-4.51,4.509-4.51h2.255c2.488,0,4.51,2.023,4.51,4.51V31.96z"
        fill="#153b5e"
        className="color000000 svgShape"
      ></path>
      <circle
        cx="50"
        cy="37.598"
        r="2.255"
        fill="#ffffff"
        className="colorffffff svgShape"
      ></circle>
      <path
        d="M50,40.98c-1.865,0-3.382-1.518-3.382-3.382c0-1.865,1.517-3.382,3.382-3.382c1.866,0,3.382,1.517,3.382,3.382
												C53.382,39.463,51.865,40.98,50,40.98z M50,36.47c-0.621,0-1.127,0.505-1.127,1.128c0,0.622,0.506,1.127,1.127,1.127
												c0.622,0,1.127-0.506,1.127-1.127C51.127,36.976,50.622,36.47,50,36.47z"
        fill="#153b5e"
        className="color000000 svgShape"
      ></path>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          fill="#ffffff"
          d="M50,42.108v-2.255V42.108z"
          className="colorffffff svgShape"
        ></path>
        <rect
          width="2.255"
          height="4.51"
          x="48.872"
          y="38.725"
          fill="#153b5e"
          className="color000000 svgShape"
        ></rect>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          fill="#9bfff3"
          d="M82.752,51.128H17.248c-0.604,0-1.151,0.243-1.548,0.637c-0.403,0.399-0.652,0.951-0.652,1.563
						v9.129c0,1.215,0.985,2.2,2.2,2.2h65.504c1.215,0,2.2-0.985,2.2-2.2v-9.129C84.952,52.112,83.967,51.128,82.752,51.128z"
          className="color9bf2ff svgShape"
        ></path>
        <path
          d="M80.442,65.785H19.558c-3.108,0-5.638-2.529-5.638-5.637v-4.509c0-3.109,2.529-5.637,5.638-5.637h60.884
						c3.108,0,5.638,2.529,5.638,5.637v4.509C86.08,63.256,83.55,65.785,80.442,65.785z M19.558,52.255
						c-1.865,0-3.382,1.517-3.382,3.382v4.509c0,1.866,1.517,3.382,3.382,3.382h60.884c1.865,0,3.382-1.517,3.382-3.382v-4.509
						c0-1.866-1.517-3.382-3.382-3.382H19.558z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
        <rect
          width="6.765"
          height="2.254"
          x="36.47"
          y="56.765"
          fill="#153b5e"
          className="color000000 svgShape"
        ></rect>
        <rect
          width="6.766"
          height="2.255"
          x="36.469"
          y="56.765"
          transform="rotate(-60 39.856 57.896)"
          fill="#153b5e"
          className="color000000 svgShape"
        ></rect>
        <rect
          width="2.255"
          height="6.766"
          x="38.725"
          y="54.509"
          transform="rotate(-29.991 39.854 57.891)"
          fill="#153b5e"
          className="color000000 svgShape"
        ></rect>
        <g fill="#153b5e" className="color000000 svgShape">
          <rect
            width="6.765"
            height="2.254"
            x="27.45"
            y="56.765"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
          <rect
            width="6.766"
            height="2.255"
            x="27.449"
            y="56.765"
            transform="rotate(-60.007 30.835 57.893)"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
          <rect
            width="2.255"
            height="6.766"
            x="29.705"
            y="54.509"
            transform="rotate(-29.991 30.834 57.892)"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
        </g>
        <g fill="#153b5e" className="color000000 svgShape">
          <rect
            width="6.765"
            height="2.254"
            x="18.43"
            y="56.765"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
          <rect
            width="6.766"
            height="2.256"
            x="18.43"
            y="56.765"
            transform="rotate(-60.007 21.815 57.893)"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
          <rect
            width="2.256"
            height="6.766"
            x="20.685"
            y="54.509"
            transform="rotate(-29.991 21.814 57.892)"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
        </g>
        <g fill="#153b5e" className="color000000 svgShape">
          <rect
            width="6.764"
            height="2.254"
            x="45.49"
            y="56.765"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
          <rect
            width="6.766"
            height="2.255"
            x="45.489"
            y="56.765"
            transform="rotate(-60 48.876 57.896)"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
          <rect
            width="2.255"
            height="6.766"
            x="47.745"
            y="54.509"
            transform="rotate(-29.991 48.874 57.891)"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
        </g>
        <g fill="#153b5e" className="color000000 svgShape">
          <rect
            width="2.255"
            height="6.764"
            x="54.51"
            y="54.51"
            fill="#153b5e"
            className="color000000 svgShape"
          ></rect>
        </g>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          fill="#55a9f6"
          d="M71.422,84.952c7.472,0,13.53-6.058,13.53-13.53s-6.058-13.529-13.53-13.529
						s-13.53,6.057-13.53,13.529S63.95,84.952,71.422,84.952z"
          className="colorf65555 svgShape"
        ></path>
        <path
          d="M71.422,86.08c-8.082,0-14.658-6.576-14.658-14.657s6.576-14.657,14.658-14.657S86.08,63.34,86.08,71.422
						S79.504,86.08,71.422,86.08z M71.422,59.02c-6.839,0-12.403,5.564-12.403,12.403s5.564,12.402,12.403,12.402
						s12.402-5.564,12.402-12.402S78.261,59.02,71.422,59.02z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M72.55 75.932h-2.255v-1.303c0-1.634 1.007-3.123 2.625-3.885 1.163-.546 1.885-1.648 1.885-2.877 0-1.71-1.581-3.21-3.382-3.21-1.865 0-3.382 1.439-3.382 3.209v1.128h-2.255v-1.128c0-3.012 2.529-5.464 5.637-5.464 3.055 0 5.637 2.503 5.637 5.465 0 2.08-1.248 4.01-3.181 4.919-.819.385-1.329 1.092-1.329 1.843V75.932zM70.295 80.442v-2.255h2.255v2.255C70.295 80.442 72.55 80.442 70.295 80.442z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M34.215,39.853v-2.255h2.255v2.255C34.215,39.853,36.47,39.853,34.215,39.853z M29.705,39.853v-2.255h2.255v2.255
			C29.705,39.853,31.96,39.853,29.705,39.853z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M68.04,39.853v-2.255h2.255v2.255C68.04,39.853,70.295,39.853,68.04,39.853z M63.53,39.853v-2.255h2.255v2.255
			C63.53,39.853,65.785,39.853,63.53,39.853z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M63.53,35.343v-2.255h2.255v2.255C63.53,35.343,65.785,35.343,63.53,35.343z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M63.53,44.363v-2.255h2.255v2.255C63.53,44.363,65.785,44.363,63.53,44.363z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M34.215,35.343v-2.255h2.255v2.255C34.215,35.343,36.47,35.343,34.215,35.343z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <path
          d="M34.215,44.363v-2.255h2.255v2.255C34.215,44.363,36.47,44.363,34.215,44.363z"
          fill="#153b5e"
          className="color000000 svgShape"
        ></path>
      </g>
      <g fill="#153b5e" className="color000000 svgShape">
        <rect
          width="18.039"
          height="2.255"
          x="36.47"
          y="69.167"
          fill="#153b5e"
          className="color000000 svgShape"
        ></rect>
      </g>
    </svg>
  );
}

export function IconoNuevoViaje(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      data-name="Layer 1"
      viewBox="0 0 128 128"
      width="75%"
      height="75%"
      id="Taxicab"
    >
      <path
        fill="#153b5e"
        d="M120.97443,92.97376h-3.62231V84.9594a1.79029,1.79029,0,0,0-1.7903-1.7903H104.32931a3.58065,3.58065,0,0,1-3.27817-2.14044L99.27372,76.9826a3.58061,3.58061,0,0,1,3.27817-5.02077h13.00993a1.7902,1.7902,0,0,0,1.7903-1.7902V68.82524a8.893,8.893,0,0,0-1.60728-5.062h4.726A5.73091,5.73091,0,0,0,126.29569,58.54a5.5202,5.5202,0,0,0-5.51218-5.81687h-5.66924a5.50483,5.50483,0,0,0-4.96014,3.13885A56.04975,56.04975,0,0,0,98.72368,35.6221a13.41961,13.41961,0,0,0-7.43385-4.21687c-16.01557-3.0456-38.56245-3.0456-54.57972,0a13.43156,13.43156,0,0,0-7.43564,4.21687,56.06316,56.06316,0,0,0-11.4286,20.24,5.50464,5.50464,0,0,0-4.96009-3.13906H7.529a5.73071,5.73071,0,0,0-5.82467,5.22307,5.52028,5.52028,0,0,0,5.51213,5.81708h5.03867a8.893,8.893,0,0,0-1.60723,5.062v1.34639a1.79019,1.79019,0,0,0,1.79025,1.7902H25.44811a3.58065,3.58065,0,0,1,3.27822,5.02077l-1.77742,4.04606a3.58072,3.58072,0,0,1-3.27822,2.14044H12.43818a1.79028,1.79028,0,0,0-1.79025,1.7903v8.01436H7.02557a5.32916,5.32916,0,0,0,0,10.65831h3.39856v11.04a3.58055,3.58055,0,0,0,3.58055,3.58051h8.12495a3.58056,3.58056,0,0,0,3.58055-3.58051v-11.04h76.35589v11.04a3.58056,3.58056,0,0,0,3.58055,3.58051h8.1249a3.58056,3.58056,0,0,0,3.5806-3.58051v-11.04h3.62231a5.32916,5.32916,0,0,0,0-10.65831ZM26.28581,58.83941a47.08742,47.08742,0,0,1,9.65242-17.23978,4.42912,4.42912,0,0,1,2.44329-1.40036c14.9097-2.83047,36.33239-2.83047,51.23691,0A4.40373,4.40373,0,0,1,92.05906,41.598a47.324,47.324,0,0,1,9.63722,17.23907A325.95,325.95,0,0,0,26.28581,58.83941ZM90.5776,92.97376H37.41717a3.58051,3.58051,0,0,1-3.26991-5.03924L38.581,77.99578a7.16115,7.16115,0,0,1,6.53988-4.24354H82.86507A7.161,7.161,0,0,1,89.40279,77.991l4.44364,9.9411A3.58048,3.58048,0,0,1,90.5776,92.97376Z"
        className="color3b4551 svgShape"
      ></path>
      <path
        fill="#07eace"
        d="M82.56468,23.7758V14.84085a3.16893,3.16893,0,0,0-2.3686-3.07791,66.106,66.106,0,0,0-32.39868,0,3.16893,3.16893,0,0,0-2.3686,3.07791v8.96649A180.54514,180.54514,0,0,1,82.56468,23.7758Z"
        className="color2e7bba svgShape"
      ></path>
    </svg>
  );
}

export function IconoNuevoViajeDisabled(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      data-name="Layer 1"
      viewBox="0 0 128 128"
      width="75%"
      height="75%"
      id="Taxicab"
    >
      <path
        fill="gainsboro"
        d="M120.97443,92.97376h-3.62231V84.9594a1.79029,1.79029,0,0,0-1.7903-1.7903H104.32931a3.58065,3.58065,0,0,1-3.27817-2.14044L99.27372,76.9826a3.58061,3.58061,0,0,1,3.27817-5.02077h13.00993a1.7902,1.7902,0,0,0,1.7903-1.7902V68.82524a8.893,8.893,0,0,0-1.60728-5.062h4.726A5.73091,5.73091,0,0,0,126.29569,58.54a5.5202,5.5202,0,0,0-5.51218-5.81687h-5.66924a5.50483,5.50483,0,0,0-4.96014,3.13885A56.04975,56.04975,0,0,0,98.72368,35.6221a13.41961,13.41961,0,0,0-7.43385-4.21687c-16.01557-3.0456-38.56245-3.0456-54.57972,0a13.43156,13.43156,0,0,0-7.43564,4.21687,56.06316,56.06316,0,0,0-11.4286,20.24,5.50464,5.50464,0,0,0-4.96009-3.13906H7.529a5.73071,5.73071,0,0,0-5.82467,5.22307,5.52028,5.52028,0,0,0,5.51213,5.81708h5.03867a8.893,8.893,0,0,0-1.60723,5.062v1.34639a1.79019,1.79019,0,0,0,1.79025,1.7902H25.44811a3.58065,3.58065,0,0,1,3.27822,5.02077l-1.77742,4.04606a3.58072,3.58072,0,0,1-3.27822,2.14044H12.43818a1.79028,1.79028,0,0,0-1.79025,1.7903v8.01436H7.02557a5.32916,5.32916,0,0,0,0,10.65831h3.39856v11.04a3.58055,3.58055,0,0,0,3.58055,3.58051h8.12495a3.58056,3.58056,0,0,0,3.58055-3.58051v-11.04h76.35589v11.04a3.58056,3.58056,0,0,0,3.58055,3.58051h8.1249a3.58056,3.58056,0,0,0,3.5806-3.58051v-11.04h3.62231a5.32916,5.32916,0,0,0,0-10.65831ZM26.28581,58.83941a47.08742,47.08742,0,0,1,9.65242-17.23978,4.42912,4.42912,0,0,1,2.44329-1.40036c14.9097-2.83047,36.33239-2.83047,51.23691,0A4.40373,4.40373,0,0,1,92.05906,41.598a47.324,47.324,0,0,1,9.63722,17.23907A325.95,325.95,0,0,0,26.28581,58.83941ZM90.5776,92.97376H37.41717a3.58051,3.58051,0,0,1-3.26991-5.03924L38.581,77.99578a7.16115,7.16115,0,0,1,6.53988-4.24354H82.86507A7.161,7.161,0,0,1,89.40279,77.991l4.44364,9.9411A3.58048,3.58048,0,0,1,90.5776,92.97376Z"
        className="color3b4551 svgShape"
      ></path>
      <path
        fill="gainsboro"
        d="M82.56468,23.7758V14.84085a3.16893,3.16893,0,0,0-2.3686-3.07791,66.106,66.106,0,0,0-32.39868,0,3.16893,3.16893,0,0,0-2.3686,3.07791v8.96649A180.54514,180.54514,0,0,1,82.56468,23.7758Z"
        className="color2e7bba svgShape"
      ></path>
    </svg>
  );
}

export function IconoHistorialViajes(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      width="50%"
      height="50%"
      id="CalendarOnline"
    >
      <path
        fill="#07eace"
        d="M265.668,341.902c6.167-14.581,14.994-27.674,26.234-38.914
		c11.24-11.241,24.333-20.067,38.914-26.234c15.076-6.377,31.083-9.615,47.577-9.626v-22.162l0,0c-6.147,0-11.13-4.983-11.13-11.13
		v-55.652H33.349V345.14c0,18.412,14.979,33.391,33.391,33.391h155.826c6.147,0,11.13,4.983,11.13,11.13l0,0h22.345
		c0-0.033-0.001-0.065-0.001-0.098C256.042,373.04,259.281,357.004,265.668,341.902z"
        className="colorff9263 svgShape"
      ></path>
      <path
        fill="#8af2e5"
        d="M367.263,100.27c0-18.412-14.979-33.391-33.391-33.391h-55.569v33.289
		c0,6.147-4.983,11.13-11.13,11.13c-6.147,0-11.13-4.983-11.13-11.13V66.879H144.739v33.289c0,6.147-4.983,11.13-11.13,11.13
		s-11.13-4.983-11.13-11.13V66.879H66.741c-18.412,0-33.391,14.979-33.391,33.391v55.652h333.913V100.27z"
        className="color8af2cb svgShape"
      ></path>
      <path
        fill="#153b5e"
        d="M222.567,378.531H66.741c-18.412,0-33.391-14.979-33.391-33.391V178.183h333.913v55.652
		c0,6.147,4.983,11.13,11.13,11.13l0,0c6.147,0,11.13-4.983,11.13-11.13v-66.783V100.27c0-14.925-5.772-28.917-16.254-39.398
		c-10.481-10.481-24.473-16.254-39.398-16.254h-55.569V11.13c0-6.147-4.983-11.13-11.13-11.13c-6.147,0-11.13,4.983-11.13,11.13
		v33.487H144.739V11.13c0-6.147-4.983-11.13-11.13-11.13s-11.13,4.983-11.13,11.13v33.487H66.741
		c-7.484,0-14.755,1.465-21.611,4.355c-6.628,2.794-12.58,6.793-17.69,11.885c-5.122,5.104-9.144,11.054-11.955,17.685
		c-2.917,6.88-4.396,14.189-4.396,21.726v66.783V345.14c0,7.487,1.48,14.767,4.399,21.638c2.811,6.617,6.828,12.564,11.938,17.675
		c5.111,5.111,11.058,9.128,17.675,11.94c6.871,2.92,14.152,4.4,21.64,4.4h155.826c6.147,0,11.13-4.983,11.13-11.13l0,0
		C233.697,383.514,228.714,378.531,222.567,378.531z M33.349,100.27c0-18.412,14.979-33.391,33.391-33.391h55.737v33.289
		c0,6.147,4.983,11.13,11.13,11.13s11.13-4.983,11.13-11.13V66.879h111.303v33.289c0,6.147,4.983,11.13,11.13,11.13
		c6.147,0,11.13-4.983,11.13-11.13V66.879h55.569c18.412,0,33.391,14.979,33.391,33.391v55.652H33.349L33.349,100.27L33.349,100.27z
		"
        className="color4d2735 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M378.477,289.388c-55.236,0-100.174,44.939-100.174,100.176s44.938,100.176,100.174,100.176
		s100.174-44.939,100.174-100.176S433.713,289.388,378.477,289.388z M422.998,400.694h-44.522c-6.147,0-11.13-4.983-11.13-11.13
		V322.78c0-6.147,4.983-11.13,11.13-11.13c6.147,0,11.13,4.983,11.13,11.13v55.653h33.391c6.147,0,11.13,4.983,11.13,11.13
		S429.146,400.694,422.998,400.694z"
        className="colorfcf3a3 svgShape"
      ></path>
      <path
        fill="#153b5e"
        d="M491.285,341.902c-6.167-14.581-14.994-27.674-26.234-38.914
		c-11.24-11.241-24.333-20.067-38.914-26.234c-15.101-6.388-31.137-9.626-47.661-9.626c-0.028,0-0.056,0-0.084,0
		c-16.494,0.011-32.501,3.249-47.577,9.626c-14.581,6.167-27.673,14.994-38.914,26.234c-11.241,11.241-20.067,24.333-26.234,38.914
		c-6.388,15.102-9.626,31.137-9.626,47.661c0,0.033,0.001,0.065,0.001,0.098c0.013,16.489,3.251,32.491,9.626,47.563
		c6.167,14.581,14.994,27.674,26.234,38.914c11.24,11.241,24.333,20.067,38.914,26.234c15.101,6.388,31.137,9.626,47.661,9.626
		c16.524,0,32.559-3.239,47.661-9.626c14.581-6.167,27.673-14.994,38.914-26.234c11.241-11.241,20.067-24.333,26.234-38.914
		c6.388-15.102,9.626-31.137,9.626-47.661S497.673,357.004,491.285,341.902z M378.477,489.739
		c-55.236,0-100.174-44.939-100.174-100.176s44.938-100.176,100.174-100.176s100.174,44.939,100.174,100.176
		S433.713,489.739,378.477,489.739z"
        className="color4d2735 svgShape"
      ></path>
      <path
        fill="#153b5e"
        d="M422.998,378.433h-33.391V322.78c0-6.147-4.983-11.13-11.13-11.13c-6.147,0-11.13,4.983-11.13,11.13
		v66.784c0,6.147,4.983,11.13,11.13,11.13h44.522c6.147,0,11.13-4.983,11.13-11.13S429.146,378.433,422.998,378.433z"
        className="color4d2735 svgShape"
      ></path>
    </svg>
  );
}

export function IconoHistorialViajes1(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      enableBackground="new 0 0 68 68"
      viewBox="0 0 68 68"
      width="70%"
      height="70%"
      id="Calendar"
    >
      <path
        fill="#153b5e"
        d="M11.11 11.28c-.53 0-.98-.42-1-.96-.01-.15-.01-.31-.01-.46 0-4.06 2.28-7.23 5.2-7.23.55 0 1 .45 1 1s-.45 1-1 1c-1.73 0-3.2 2.4-3.2 5.23 0 .13 0 .25.01.38.02.55-.41 1.02-.96 1.04C11.14 11.28 11.12 11.28 11.11 11.28zM24.97 11.28c-.53 0-.97-.42-1-.95-.01-.16-.01-.31-.01-.47 0-4.06 2.28-7.23 5.2-7.23.55 0 1 .45 1 1s-.45 1-1 1c-1.73 0-3.2 2.4-3.2 5.23 0 .12 0 .25.01.37.03.55-.4 1.02-.95 1.05C25 11.28 24.98 11.28 24.97 11.28zM38.83 11.28c-.53 0-.98-.42-1-.96-.01-.15-.01-.31-.01-.46 0-4.06 2.28-7.23 5.2-7.23.55 0 1 .45 1 1s-.45 1-1 1c-1.73 0-3.2 2.4-3.2 5.23 0 .13 0 .25.01.38.02.55-.41 1.02-.96 1.04C38.86 11.28 38.84 11.28 38.83 11.28zM52.69 11.28c-.53 0-.98-.42-1-.96-.01-.15-.01-.31-.01-.46 0-4.06 2.28-7.23 5.2-7.23.55 0 1 .45 1 1s-.45 1-1 1c-1.73 0-3.2 2.4-3.2 5.23 0 .13 0 .25.01.38.02.55-.41 1.02-.96 1.04C52.72 11.28 52.7 11.28 52.69 11.28z"
        className="color0e4a77 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M66,16.02V58.8c0,3.63-2.94,6.56-6.56,6.56H8.56C4.94,65.37,2,62.43,2,58.8V16.02c0-3.63,2.94-6.56,6.56-6.56
			h50.87C63.06,9.46,66,12.4,66,16.02z"
        className="colordfe9f4 svgShape"
      ></path>
      <path
        fill="#dc030e"
        d="M61.23,9.71V21.2c0,20.76-16.83,37.59-37.59,37.59H2v0.02c0,3.63,2.94,6.56,6.56,6.56h50.87
			c3.63,0,6.56-2.94,6.56-6.56V16.02C66,13.02,63.98,10.49,61.23,9.71z"
        className="colorcfdae5 svgShape"
      ></path>
      <path
        fill="#07eace"
        d="M66,21.81v-5.78c0-3.63-2.94-6.56-6.56-6.56H8.56C4.94,9.46,2,12.4,2,16.02v5.78H66z"
        className="color00cc99 svgShape"
      ></path>
      <path
        fill="#04aa95"
        d="M17.2 16.1c0 1.38-1.12 2.5-2.5 2.5-1.38 0-2.5-1.12-2.5-2.5 0-1.38 1.12-2.5 2.5-2.5C16.08 13.6 17.2 14.72 17.2 16.1zM31.06 16.1c0 1.38-1.12 2.5-2.5 2.5-1.38 0-2.5-1.12-2.5-2.5 0-1.38 1.12-2.5 2.5-2.5C29.94 13.6 31.06 14.72 31.06 16.1zM44.92 16.1c0 1.38-1.12 2.5-2.5 2.5-1.38 0-2.5-1.12-2.5-2.5 0-1.38 1.12-2.5 2.5-2.5C43.8 13.6 44.92 14.72 44.92 16.1zM58.78 16.1c0 1.38-1.12 2.5-2.5 2.5-1.38 0-2.5-1.12-2.5-2.5 0-1.38 1.12-2.5 2.5-2.5C57.66 13.6 58.78 14.72 58.78 16.1z"
        className="color04aa77 svgShape"
      ></path>
      <path
        fill="#153b5e"
        d="M15.3 17.1c-.55 0-1-.45-1-1s.45-1 1-1c1.74 0 3.2-2.4 3.2-5.23 0-2.84-1.47-5.23-3.2-5.23-.55 0-1-.45-1-1s.45-1 1-1c2.92 0 5.2 3.18 5.2 7.23C20.5 13.92 18.21 17.1 15.3 17.1zM29.16 17.1c-.55 0-1-.45-1-1s.45-1 1-1c1.74 0 3.2-2.4 3.2-5.23 0-2.84-1.47-5.23-3.2-5.23-.55 0-1-.45-1-1s.45-1 1-1c2.92 0 5.2 3.18 5.2 7.23C34.36 13.92 32.07 17.1 29.16 17.1zM43.02 17.1c-.55 0-1-.45-1-1s.45-1 1-1c1.74 0 3.2-2.4 3.2-5.23 0-2.84-1.47-5.23-3.2-5.23-.55 0-1-.45-1-1s.45-1 1-1c2.92 0 5.2 3.18 5.2 7.23C48.22 13.92 45.93 17.1 43.02 17.1zM56.88 17.1c-.55 0-1-.45-1-1s.45-1 1-1c1.74 0 3.2-2.4 3.2-5.23 0-2.84-1.47-5.23-3.2-5.23-.55 0-1-.45-1-1s.45-1 1-1c2.92 0 5.2 3.18 5.2 7.23C62.08 13.92 59.79 17.1 56.88 17.1z"
        className="color0e4a77 svgShape"
      ></path>
      <path
        fill="#d4c5a7"
        d="M16.86 29.2v5.49c0 .55-.45 1-1 1H10c-.55 0-1-.45-1-1V29.2c0-.55.45-1 1-1h5.86C16.41 28.2 16.86 28.64 16.86 29.2zM31 29.2v5.49c0 .55-.45 1-1 1h-5.86c-.55 0-1-.45-1-1V29.2c0-.55.45-1 1-1H30C30.56 28.2 31 28.64 31 29.2zM45.15 29.2v5.49c0 .55-.45 1-1 1H38.3c-.55 0-1-.45-1-1V29.2c0-.55.45-1 1-1h5.86C44.71 28.2 45.15 28.64 45.15 29.2zM59.31 29.2v5.49c0 .55-.45 1-1 1h-5.86c-.55 0-1-.45-1-1V29.2c0-.55.45-1 1-1h5.86C58.86 28.2 59.31 28.64 59.31 29.2zM16.86 41.11v5.49c0 .55-.45 1-1 1H10c-.55 0-1-.45-1-1v-5.49c0-.55.45-1 1-1h5.86C16.41 40.11 16.86 40.56 16.86 41.11zM45.15 41.11v5.49c0 .55-.45 1-1 1H38.3c-.55 0-1-.45-1-1v-5.49c0-.55.45-1 1-1h5.86C44.71 40.11 45.15 40.56 45.15 41.11z"
        className="colorafa7d4 svgShape"
      ></path>
      <path
        fill="#e7a218"
        d="M59.31,41.11v5.49c0,0.55-0.45,1-1,1h-5.86c-0.55,0-1-0.45-1-1v-5.49c0-0.55,0.45-1,1-1h5.86
			C58.86,40.11,59.31,40.56,59.31,41.11z"
        className="colorf34c6e svgShape"
      ></path>
      <path
        fill="#d4c5a7"
        d="M16.86,53.03v5.49c0,0.55-0.45,1-1,1H10c-0.55,0-1-0.45-1-1v-5.49c0-0.55,0.45-1,1-1h5.86
			C16.41,52.03,16.86,52.48,16.86,53.03z"
        className="colorafa7d4 svgShape"
      ></path>
      <path
        fill="#e7a218"
        d="M31,53.03v5.49c0,0.55-0.45,1-1,1h-5.86c-0.55,0-1-0.45-1-1v-5.49c0-0.55,0.45-1,1-1H30
			C30.56,52.03,31,52.48,31,53.03z"
        className="colorf34c6e svgShape"
      ></path>
      <path
        fill="#d4c5a7"
        d="M45.15 53.03v5.49c0 .55-.45 1-1 1H38.3c-.55 0-1-.45-1-1v-5.49c0-.55.45-1 1-1h5.86C44.71 52.03 45.15 52.48 45.15 53.03zM59.31 53.03v5.49c0 .55-.45 1-1 1h-5.86c-.55 0-1-.45-1-1v-5.49c0-.55.45-1 1-1h5.86C58.86 52.03 59.31 52.48 59.31 53.03zM31 41.11v5.49c0 .55-.45 1-1 1h-5.86c-.55 0-1-.45-1-1v-5.49c0-.55.45-1 1-1H30C30.56 40.11 31 40.56 31 41.11z"
        className="colorafa7d4 svgShape"
      ></path>
      <path
        fill="#070707"
        d="M58.31 28.2h-.25v0c0 3.45-2.79 6.24-6.24 6.24h-.36v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1V29.2C59.31 28.64 58.86 28.2 58.31 28.2zM44.15 28.2H43.9v0c0 3.45-2.79 6.24-6.24 6.24H37.3v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1V29.2C45.15 28.64 44.71 28.2 44.15 28.2zM30 28.2h-.25v0c0 3.45-2.79 6.24-6.24 6.24h-.36v.25c0 .55.45 1 1 1H30c.55 0 1-.45 1-1V29.2C31 28.64 30.55 28.2 30 28.2zM15.84 28.2h-.25v0c0 3.45-2.79 6.24-6.24 6.24H8.99v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1V29.2C16.84 28.64 16.4 28.2 15.84 28.2zM58.31 40.11h-.25v0c0 3.45-2.79 6.24-6.24 6.24h-.36v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1v-5.49C59.31 40.56 58.86 40.11 58.31 40.11zM44.15 40.11H43.9v0c0 3.45-2.79 6.24-6.24 6.24H37.3v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1v-5.49C45.15 40.56 44.71 40.11 44.15 40.11zM30 40.11h-.25v0c0 3.45-2.79 6.24-6.24 6.24h-.36v.25c0 .55.45 1 1 1H30c.55 0 1-.45 1-1v-5.49C31 40.56 30.55 40.11 30 40.11zM15.84 40.11h-.25v0c0 3.45-2.79 6.24-6.24 6.24H8.99v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1v-5.49C16.84 40.56 16.4 40.11 15.84 40.11zM58.31 52.03h-.25v0c0 3.45-2.79 6.24-6.24 6.24h-.36v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1v-5.49C59.31 52.48 58.86 52.03 58.31 52.03zM44.15 52.03H43.9v0c0 3.45-2.79 6.24-6.24 6.24H37.3v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1v-5.49C45.15 52.48 44.71 52.03 44.15 52.03zM30 52.03h-.25v0c0 3.45-2.79 6.24-6.24 6.24h-.36v.25c0 .55.45 1 1 1H30c.55 0 1-.45 1-1v-5.49C31 52.48 30.55 52.03 30 52.03zM15.84 52.03h-.25v0c0 3.45-2.79 6.24-6.24 6.24H8.99v.25c0 .55.45 1 1 1h5.86c.55 0 1-.45 1-1v-5.49C16.84 52.48 16.4 52.03 15.84 52.03z"
        opacity=".1"
        className="color070707 svgShape"
      ></path>
    </svg>
  );
}

export function IconoBilletera(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      viewBox="0 0 512 512"
      id="Wallet"
      width="75%"
      height="75%"
    >
      <path
        fill="#07eace"
        d="M175.7 189.26H44.86c0-5.41.92-10.6 2.62-15.43 6.36-18.09 23.6-31.06 43.87-31.07v.01h58.97c2.09 11.29 6.4 21.8 12.45 31.06a86.14 86.14 0 0 0 12.93 15.43z"
        className="color526471 svgShape"
      ></path>
      <path
        fill="#dc030e"
        d="M319.63 126.53c.04 5.55-.45 10.98-1.43 16.24a84.71 84.71 0 0 1-12.45 31.06 85.381 85.381 0 0 1-12.93 15.43H175.7a86.14 86.14 0 0 1-12.93-15.43 85.058 85.058 0 0 1-12.45-31.06c-.9-4.87-1.38-9.88-1.42-15-.34-47.14 37.6-85.64 84.74-85.98h.62c46.87-.02 85.03 37.81 85.37 84.74z"
        className="colorffc035 svgShape"
      ></path>
      <path
        fill="#07eace"
        d="M393.56 189.26H292.82c4.89-4.6 9.24-9.79 12.93-15.43a84.71 84.71 0 0 0 12.45-31.06h20.31v-.01h8.55c20.27 0 37.51 12.97 43.88 31.07 1.7 4.83 2.62 10.02 2.62 15.43z"
        className="color526471 svgShape"
      ></path>
      <path
        fill="#f0efec"
        d="M338.52 307.09c12.84 0 23.25 10.41 23.25 23.25 0 12.85-10.41 23.26-23.25 23.26-12.85 0-23.26-10.41-23.26-23.26 0-12.84 10.41-23.25 23.26-23.25z"
        className="coloreceff0 svgShape"
      ></path>
      <path
        fill="#757f89"
        d="M338.52 283.83c-25.49 0-46.19 20.5-46.51 45.91-.01.2-.01.41-.01.61 0 25.68 20.83 46.5 46.52 46.5h126.79v-93.02H338.52zm23.25 46.51c0 12.85-10.41 23.26-23.25 23.26-12.85 0-23.26-10.41-23.26-23.26 0-.2 0-.4.02-.6.31-12.56 10.59-22.65 23.24-22.65 12.64 0 22.92 10.09 23.24 22.65.01.2.01.4.01.6z"
        className="color758289 svgShape"
      ></path>
      <path
        fill="none"
        d="M465.31 424.92V235.77M91.35 142.77h58.97M338.51 142.77H318.2M418.81 470.21H91.36M465.32 423.71c0 .4 0 .81-.01 1.21-.64 25.11-21.23 45.29-46.5 45.29M44.86 423.7c0 25.69 20.82 46.51 46.5 46.51M465.31 235.77c0-25.68-20.81-46.51-46.5-46.51H44.86M91.36 142.76h-.01c-25.68.01-46.49 20.82-46.49 46.5M347.06 142.76h-8.55M393.56 189.26c0-25.68-20.82-46.5-46.5-46.5M44.85 423.71V189.26M338.52 376.85c-25.69 0-46.52-20.82-46.52-46.5 0-25.69 20.83-46.52 46.52-46.52M338.52 283.83h126.79M465.31 376.85H338.52"
      ></path>
      <path
        fill="none"
        d="M338.52 307.09c12.84 0 23.25 10.41 23.25 23.25 0 12.85-10.41 23.26-23.25 23.26-12.85 0-23.26-10.41-23.26-23.26 0-12.84 10.41-23.25 23.26-23.25zM175.7 189.26c-12.9-12.17-22.02-28.31-25.38-46.49-.9-4.87-1.38-9.88-1.42-15-.34-47.14 37.6-85.64 84.74-85.98 47.15-.35 85.65 37.6 85.99 84.74.04 5.55-.45 10.98-1.43 16.24-3.35 18.16-12.46 34.32-25.38 46.49"
      ></path>
      <path
        fill="#153b5e"
        d="M292 330.35c0 25.68 20.83 46.5 46.52 46.5h126.79v48.07c-.64 25.11-21.23 45.29-46.5 45.29H91.36c-25.68 0-46.5-20.82-46.5-46.51h-.01V189.26h373.96c25.69 0 46.5 20.83 46.5 46.51v48.06H338.52c-25.69 0-46.52 20.83-46.52 46.52z"
        className="color303c44 svgShape"
      ></path>
      <path
        fill="#e7a218"
        d="m238.6 172.87.11 16.36v.03h-8l-.11-16.01-17.03.12h-.03c-2.2 0-3.98-1.77-4-3.97a3.999 3.999 0 0 1 3.97-4.03l21.03-.15c9.39-.07 16.97-7.77 16.91-17.16-.06-9.35-7.7-16.91-17.04-16.91h-.3c-6.62 0-12.85-2.55-17.57-7.2-4.77-4.7-7.41-10.97-7.46-17.65-.05-6.69 2.51-13 7.2-17.76 3.75-3.79 8.49-6.24 13.65-7.1l-.14-19.96a3.999 3.999 0 0 1 3.97-4.03h.03c2.2 0 3.98 1.77 4 3.97l.14 19.64 17.03-.13h.03c2.2 0 3.98 1.77 4 3.97a3.999 3.999 0 0 1-3.97 4.03l-21.03.16c-9.39.06-16.97 7.76-16.91 17.15.03 4.55 1.83 8.82 5.07 12.01 3.24 3.19 7.49 4.95 12.08 4.9h.18c13.73 0 24.95 11.11 25.04 24.85.09 12.44-8.96 22.85-20.85 24.87z"
        className="colorc98b0e svgShape"
      ></path>
      <path
        d="M393.56 189.26H44.86c0-5.41.92-10.6 2.62-15.43h343.46c1.7 4.83 2.62 10.02 2.62 15.43z"
        opacity=".2"
        fill="#000000"
        className="color000000 svgShape"
      ></path>
      <linearGradient
        id="a"
        x1="378.655"
        x2="378.655"
        y1="329.74"
        y2="376.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0"></stop>
        <stop
          offset="1"
          stopColor="#ffffff"
          stopOpacity="0"
          className="stopColorffffff svgShape"
        ></stop>
      </linearGradient>
      <path
        fill="url(#a)"
        d="M465.31 329.74v47.11H338.52c-25.69 0-46.52-20.82-46.52-46.5 0-.2 0-.41.01-.61h173.3z"
        opacity=".2"
      ></path>
      <linearGradient
        id="b"
        x1="234.26"
        x2="319.632"
        y1="115.525"
        y2="115.525"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0"></stop>
        <stop
          offset="1"
          stopColor="#ffffff"
          stopOpacity="0"
          className="stopColorffffff svgShape"
        ></stop>
      </linearGradient>
      <path
        fill="url(#b)"
        d="M319.63 126.53c.04 5.55-.45 10.98-1.43 16.24a84.71 84.71 0 0 1-12.45 31.06 85.381 85.381 0 0 1-12.93 15.43h-58.56V41.79c46.87-.02 85.03 37.81 85.37 84.74z"
        opacity=".2"
      ></path>
    </svg>
  );
}

export function IconoBilletera1(props) {
  return (
    <svg
      xmlns="https://www.w3.org//2000/svg"
      viewBox="0 0 24 24"
      id="Wallet"
      width="50%"
      height="50%"
    >
      <path
        fill="#07eace"
        d="M4 1h15a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
        className="color039be5 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M19 1H4a1 1 0 0 0-1 1v.25a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1V2a1 1 0 0 0-1-1z"
        opacity=".2"
        className="colorffffff svgShape"
      ></path>
      <path
        fill="#dc030e"
        d="M20 7H3c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h17c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2z"
        className="colorbf6a1e svgShape"
      ></path>
      <path
        d="M20 22.75H3c-1.103 0-2-.897-2-2V21c0 1.103.897 2 2 2h17c1.103 0 2-.897 2-2v-.25c0 1.103-.897 2-2 2z"
        opacity=".1"
        fill="#000000"
        className="color000000 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M20 7H3c-1.103 0-2 .897-2 2v.25c0-1.103.897-2 2-2h17c1.103 0 2 .897 2 2V9c0-1.103-.897-2-2-2z"
        opacity=".2"
        className="colorffffff svgShape"
      ></path>
      <path
        fill="#d5a647"
        d="M22 12h-3.882c-1.45 0-2.783.978-3.06 2.402A3.005 3.005 0 0 0 18 18h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
        className="colord58347 svgShape"
      ></path>
      <path
        d="M22.047 17.75h-4.063a3.074 3.074 0 0 1-2.923-2.146C15.349 16.96 16.559 18 18 18h4a.98.98 0 0 0 .98-.817c-.16.345-.522.567-.933.567z"
        opacity=".1"
        fill="#000000"
        className="color000000 svgShape"
      ></path>
      <circle
        cx="18"
        cy="15"
        r="1"
        fill="#e7a218"
        className="colorf9c20a svgShape"
      ></circle>
      <linearGradient
        id="a"
        x1="17.094"
        x2="18.906"
        y1="14.577"
        y2="15.423"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stopColor="#ffffff"
          stopOpacity=".2"
          className="stopColorffffff svgShape"
        ></stop>
        <stop
          offset="1"
          stopColor="#ffffff"
          stopOpacity="0"
          className="stopColorffffff svgShape"
        ></stop>
      </linearGradient>
      <circle cx="18" cy="15" r="1" fill="url(#a)"></circle>
      <path
        fill="#ffffff"
        d="M22.047 12.25h-4.063a3.059 3.059 0 0 0-2.922 2.13C15.322 12.977 16.706 12 18 12h4c.495 0 .9.345.98.817-.16-.345-.522-.567-.933-.567z"
        opacity=".2"
        className="colorffffff svgShape"
      ></path>
      <linearGradient
        id="b"
        x1="17.588"
        x2="21.777"
        y1="16.204"
        y2="20.393"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stopColor="#23313e"
          stopOpacity=".2"
          className="stopColor3e2723 svgShape"
        ></stop>
        <stop
          offset="1"
          stopColor="#23313e"
          stopOpacity=".02"
          className="stopColor3e2723 svgShape"
        ></stop>
      </linearGradient>
      <path
        fill="url(#b)"
        d="m16 17.232 5.286 5.287C21.72 22.15 22 21.61 22 21v-3h-4c-.763 0-1.47-.297-2-.768z"
      ></path>
      <path
        fill="#153b5e"
        d="M3 3h17v3H3z"
        className="color303c42 svgShape"
      ></path>
      <path
        fill="#ffffff"
        d="M3 3h17v1.5H3z"
        opacity=".05"
        className="colorffffff svgShape"
      ></path>
      <linearGradient
        id="c"
        x1=".494"
        x2="23.633"
        y1="7.152"
        y2="17.942"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stopColor="#ffffff"
          stopOpacity=".2"
          className="stopColorffffff svgShape"
        ></stop>
        <stop
          offset="1"
          stopColor="#ffffff"
          stopOpacity="0"
          className="stopColorffffff svgShape"
        ></stop>
      </linearGradient>
      <path
        fill="url(#c)"
        d="M22 12V9c0-1.103-.897-2-2-2V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h17c1.103 0 2-.897 2-2v-3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
      ></path>
    </svg>
  );
}
